import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAddressConfiguration } from '../../context/AddressConfigurationContext/AddressConfigurationContext.js';
import Address from './Address.js';
import { getAddressRows, parseAddress } from './utils.js';

const AddressContainer = (_param)=>{
    var { size ='COMPLETE' , data ={} , prepend  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "size",
        "data",
        "prepend"
    ]);
    const config = useAddressConfiguration();
    const rows = React.useMemo(()=>{
        const templateRows = getAddressRows(size, config);
        if (templateRows.length) {
            const addressRows = parseAddress(templateRows, data);
            if (prepend) {
                addressRows[0] = `${prepend}${addressRows[0]}`;
            }
            return addressRows;
        }
        const feedback = `No configuration for address size ${size}`;
        console.error(feedback);
        return [
            `[${feedback}]`
        ];
    }, [
        size,
        config,
        data,
        prepend
    ]);
    return /*#__PURE__*/ React.createElement(Address, swcHelpers.extends({}, rest, {
        rows: rows
    }));
};

export { AddressContainer as default };
//# sourceMappingURL=AddressContainer.js.map
